import React, { useEffect } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import Transportation from "../Images/6.jpg";

const InternationalTransportation = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1100px",
        margin: "auto",
        marginTop: "60px",
      }}
    >
      {/* Main Title */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: { xs: "1.75rem", lg: "2rem" },
          fontWeight: "bold",
          textAlign: { xs: "left", md: "center" },
          mb: 4,
        }}
      >
        International Transportation
      </Typography>

      {/* Introduction Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.2rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
          mb: 4,
        }}
      >
        Take advantage of our active weekly transport routes connecting the UK
        with the Middle East and neighbouring regions. UK TO MARS LTD operates
        its own logistics network, ensuring you receive reliable and
        cost-effective shipping, every time.
      </Typography>

      {/* Two-column layout for content and transportation image */}
      <Grid container spacing={4}>
        {/* Left column - Features list */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              color: "#1e3a8a",
              fontSize: "1.5rem",
              fontWeight: "bold",
              "@media (min-width: 1024px)": { fontSize: "1.75rem" },
              mb: 3,
            }}
          >
            Key features:
          </Typography>

          <List sx={{ mb: 4 }}>
            {[
              "Scheduled weekly departures from our UK warehouse",
              "Full trailer loads (FTL), groupage, and flexible load options",
              "Real-time shipment tracking and proactive communication",
              "Customs transit documentation handled by our team",
              "Door-to-door solutions with secure, on-time delivery",
            ].map((item, index) => (
              <ListItem key={index} sx={{ padding: "4px 0" }}>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      sx={{
                        color: "#1D1616",
                        fontSize: "1.2rem",
                        "@media (min-width: 1024px)": { fontSize: "1.3rem" },
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>•</span> {item}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>

          <Typography
            variant="body1"
            paragraph
            sx={{
              color: "#1D1616",
              fontSize: "1.2rem",
              "@media (min-width: 1024px)": { fontSize: "1.4rem" },
              mb: 4,
            }}
          >
            With our established routes and dedicated transport fleet, your
            goods travel quickly and safely from the UK the destination country
          </Typography>
        </Grid>

        {/* Right column - Transportation image */}
        <Grid item xs={12} md={6}>
          <Box>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                height: "100%",
              }}
            >
              <img
                src={Transportation}
                alt="International Transportation"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ContactChat />
    </Box>
  );
};

export default InternationalTransportation;
